import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";

const PaginationButtonToolbar = ({
  selectedOption,
  pageNumber,
  totalPageNumber,
  setPageNumber,
  type,
}) => {
  const isPreviousDisabled = pageNumber === 1;
  const isPreviousTwoDisabled = pageNumber === 2;
  const isPreviousThreeDisabled = pageNumber < 4;
  const isPreviousFiveDisabled = pageNumber < 5;
  const isNextDisabled = pageNumber === totalPageNumber;
  const isNextTwoDisabled = pageNumber === totalPageNumber - 1;
  const isNextThreeDisabled = pageNumber > totalPageNumber - 3;
  const isNextFiveDisabled = pageNumber > totalPageNumber - 5;

  const handleButtonClick = (change) => {
    const newPage = pageNumber + change;
    if (newPage >= 1 && newPage <= totalPageNumber) {
      setPageNumber(newPage);
    }
  };

  const goToFirstPage = () => {
    setPageNumber(1);
  };

  const goToLastPage = () => {
    setPageNumber(totalPageNumber);
  };

  return (
    <ButtonToolbar aria-label="Toolbar with button groups mx-auto d-inline">
      <ButtonGroup className="me-2" aria-label="First group">
        <Button
          className={`border-1 ${isPreviousDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={goToFirstPage}
        >
          1
        </Button>
        <Button
          className={`border-1 ${isPreviousFiveDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={() => handleButtonClick(-10)}
        >
          ...
        </Button>
        <Button
          className={`border-1 ${isPreviousThreeDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={() => handleButtonClick(-2)}
        >
          {pageNumber - 2}
        </Button>
        <Button
          className={`border-1 ${
            isPreviousDisabled || isPreviousTwoDisabled ? "d-none" : ""
          }`}
          variant="secondary"
          onClick={() => handleButtonClick(-1)}
        >
          {pageNumber - 1}
        </Button>
        <Button
          variant="secondary"
          className={`border-1 ${isPreviousDisabled ? "disabled" : ""}`}
          onClick={() => handleButtonClick(-1)}
        >
          &#8249;
        </Button>
        <Button
          variant="secondary"
          className={`border-1 ${
            (isPreviousDisabled || isNextDisabled) &&
            pageNumber > totalPageNumber
              ? "d-none"
              : "active"
          }`}
          onClick={() => handleButtonClick(-1)}
        >
          {pageNumber}
        </Button>
        <Button
          className={`border-1 ${isNextDisabled ? "disabled" : ""}`}
          variant="secondary"
          onClick={() => handleButtonClick(1)}
        >
          &#8250;
        </Button>
        <Button
          className={`border-1 ${
            isNextDisabled || isNextTwoDisabled ? "d-none" : ""
          }`}
          variant="secondary"
          onClick={() => handleButtonClick(+1)}
        >
          {pageNumber + 1}
        </Button>
        <Button
          className={`border-1 ${isNextThreeDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={() => handleButtonClick(+2)}
        >
          {pageNumber + 2}
        </Button>
        <Button
          className={`border-1 ${isNextFiveDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={() => handleButtonClick(+10)}
        >
          ...
        </Button>
        <Button
          className={`border-1 ${isNextDisabled ? "d-none" : ""}`}
          variant="secondary"
          onClick={goToLastPage}
        >
          {totalPageNumber}
        </Button>
      </ButtonGroup>
    </ButtonToolbar>
  );
};

export default PaginationButtonToolbar;
